import { render, staticRenderFns } from "./ItineraryDayEmpty.vue?vue&type=template&id=52e78728&"
import script from "./ItineraryDayEmpty.vue?vue&type=script&lang=js&"
export * from "./ItineraryDayEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports